import styled from "styled-components";

export const StyledFooterWrapper = styled.div<any>`
  position: fixed;
  left: 0;
  bottom: 0;
  margin-left: ${(props) => (props.marginleft ? props.marginleft : "")};
  justify-content: space-between;
  border-top-width: 1px;
  display: flex;
  width: ${(props) => (props.width ? props.width : "")};
  padding: 1.5rem 4.5rem;
  border-top: 1px solid #c7c7c7;
  background: rgba(255, 255, 255, 0.76);
  backdrop-filter: blur(7.5px);
`;
